export default __webpack_public_path__ + "static/media/osteopathie.cb193ede.jpg";